import React from 'react';
import PropTypes from 'prop-types';

import StoreLocation from './store-location';
import { operationalHoursError } from './constants';

const renderOperationalHours = (text, operationalHours) => {
  return (
    <table className="hours">
      <thead>
        <tr>
          <th colSpan="2">{text}</th>
        </tr>
      </thead>
      <tbody>
        {
          operationalHours === operationalHoursError
            ? <tr><td colSpan="2">{operationalHoursError}</td></tr>
            : operationalHours.map(({ days, hours }) => (
              <tr key={days}>
                <td>{days}</td>
                <td className="text-bold">{hours}</td>
              </tr>
            ))
        }
      </tbody>
    </table>
  );
}

const renderOpeningTimes = (showInfo, storeOpenUntil, photoOpenUntil) => {
  if (showInfo) {
    if (!storeOpenUntil && !photoOpenUntil) {
      return null;
    }

    return (
      <small className="store-open">
        <div>
          {storeOpenUntil && <div>Store</div>}
          {photoOpenUntil && <div>Photo</div>}
        </div>
        <div>
          {storeOpenUntil && <div>{storeOpenUntil}</div>}
          {photoOpenUntil && <div>{photoOpenUntil}</div>}
        </div>
      </small>
    );
  }

  if (photoOpenUntil) {
    return (
      <small className="store-open">
        <div>{photoOpenUntil}</div>
      </small>
    );
  }

  return null;
}

const StoreDetails = ({ listNumber, showMiles, showInfo, location }) => {
  const store = new StoreLocation(location);
  const { googleMapDirectionsUrl: directionsUrl, storeOpenUntil, photoOpenUntil } = store;

  return (
    <div className="store-details">
      <div className="info">
        {Number(listNumber) ? <h5 className="index">{listNumber}.</h5> : null}

        <div className="address">
          <h5>{store.address.city}</h5>
          <div>
            {store.name} #{store.id}
          </div>
          <div>{store.address.street}</div>
          {renderOpeningTimes(showInfo, storeOpenUntil, photoOpenUntil)}
        </div>

        {showMiles && <a href={directionsUrl} target='_blank' rel='noopener noreferrer' className="miles">
          {store.distance.miles} mi
        </a>}
      </div>

      {showInfo && <div className="extra-info">
        <div>
          <img alt='store-opening-time' src="/images/icons/store_finder/clock-gray.svg" />
          {renderOperationalHours('Store', store.storeOperationalHours)}
        </div>
        <div>
          <img alt='photostore-opening-time' src="/images/icons/store_finder/photo-center-gray.svg" />
          {renderOperationalHours('Photo', store.photoOperationalHours)}
        </div>
        <a href={directionsUrl} target='_blank' rel='noopener noreferrer'>
          <img alt='store-distance' src="/images/icons/store_finder/directions-black.svg" />
          <div>{store.distance.miles} mi</div>
        </a>
        <a href={`tel:${store.phone}`} target="_self">
          <img alt='store-phone-number' src="/images/icons/store_finder/phone-black.svg" />
          <div>{store.phone}</div>
        </a>
      </div>}
    </div>
  );
}

StoreDetails.propTypes = {
  listNumber: PropTypes.number,
  showMiles: PropTypes.bool,
  showInfo: PropTypes.bool,
  location: PropTypes.shape({
    phone: PropTypes.string,
    distance: PropTypes.object,
    address: PropTypes.object,
    id: PropTypes.string,
  }).isRequired,
};

StoreDetails.defaultProps = {
  listNumber: null,
  showMiles: false,
  showInfo: false,
};

export default StoreDetails;
